module.exports = __webpack_public_path__ + "img/jifen.cbd4acb9.png";